import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { BookmarksPageRoutingModule } from './bookmarks-routing.module';

import { BookmarksPage } from './bookmarks.page';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { BookmarkItemComponent } from "../home/bookmarks-slider/bookmark-item/bookmark-item.component";
import { BookmarksSliderComponent } from "../home/bookmarks-slider/bookmarks-slider.component";
import { SwiperModule } from 'swiper/angular';
import { initSwiper } from '../../shared/swiper-init';

initSwiper();

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        BookmarksPageRoutingModule,
        LocalizeRouterModule,
        TranslateModule,
        SwiperModule,
        BookmarksPage, BookmarkItemComponent, BookmarksSliderComponent,
    ]
})
export class BookmarksPageModule {}
